import React, { useState } from "react";
import { Menu } from "@material-ui/icons";

import { Styles } from './style/navStyle'

const navigationItems = [
  { title: "خانه", href: "#home" },
  { title: "طلا و ارز", href: "#rates" },
  { title: "درباره ما", href: "#about-us" },
  { title: "درخواست", href: "#request" },
];

const SCROLL_DURATION = 1200;

const getTargetPosition = (target, offset = 0) =>
  target.getBoundingClientRect().top + window.scrollY - offset;

const scrollToTarget = (target, offset) => {
  const startPosition = window.scrollY;
  const targetPosition = getTargetPosition(target, offset);
  const distance = targetPosition - startPosition;
  const startTime = performance.now();

  const animateScroll = (currentTime) => {
    const progress = Math.min((currentTime - startTime) / SCROLL_DURATION, 1);
    const easedProgress = 1 - Math.pow(1 - progress, 2);

    window.scrollTo(0, startPosition + distance * easedProgress);

    if (progress < 1) {
      window.requestAnimationFrame(animateScroll);
    }
  };

  animateScroll(startTime + 16);
};

const Nav = () => {
  const [show, setShow] = useState(false)

  const handleNavigation = (event, href) => {
    event.preventDefault();

    const target = document.querySelector(href);
    const mobileHeader = event.currentTarget.closest(".mobile-header");
    const mobileMenuHeight = mobileHeader
      ? mobileHeader.getBoundingClientRect().height
      : 0;

    if (target) {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (prefersReducedMotion) {
        window.scrollTo(0, getTargetPosition(target, mobileMenuHeight));
      } else {
        scrollToTarget(target, mobileMenuHeight);
      }

      window.history.replaceState(null, "", href);
    }

    setShow(false);
  };

  return (
    <Styles>
      <div className="nav">
        <div className="banner">
          <div>اپلیکیشن صرافی اسدزاده بزودی دستیار خرید و فروش شما خواهد بود.</div>
        </div>
        <div className="header">
          <div className="logo">
            <span className="logo-mark">
              <img alt="لوگوی صرافی اسدزاده" src="/image/new_logo.png" />
            </span>
            <div className="logo-text">صرافی اسدزاده</div>
          </div>
          <div className="menu">
            {navigationItems.map((item) => (
              <a
                className="item"
                href={item.href}
                key={item.href}
                onClick={(event) => handleNavigation(event, item.href)}
              >
                {item.title}
              </a>
            ))}
          </div>
          <div className="action lg-hide">
            <Menu className="icon menu-icon" onClick={() => setShow(!show)} />
          </div>
        </div>
        {show && (
          <div className="mobile-header">
            <div className="mobile-menu">
              {navigationItems.map((item) => (
                <a
                  className="item"
                  href={item.href}
                  key={item.href}
                  onClick={(event) => handleNavigation(event, item.href)}
                >
                  {item.title}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </Styles>
  );
}
export default Nav
